<template>
  <div class="full-screen">
    <div class="main scroll-list" style="z-index: 1; height: calc(100% - 50px);">
      <div class="my-title">
        <div class="content">
          <img src="../../assets/img/user.png" id="userHeadImg" class="content-l">
          <div class="content-r">
            <p class="username">
              <span id="userAccount">{{ userInfo.account }}</span>
              <img v-if="userInfo.vipType === 'none'" src="../../assets/img/icon-vip2.png"/>
              <img v-else src="../../assets/img/icon-vip.png"/>
            </p>
            <p class="userid" id="userPassword">密码: {{ userInfo.password }} </p>
            <!-- <div class="ts"><span>请务必截图保存账户密码</span></div> -->
          </div>
          <div class="yj">永久域名：llmhuu.com<span @click="copyUrl('llmhuu.com')">复制</span></div>
        </div>

      </div>

      <div class="bd-content">
        <div class="c-top">
          <div class="c-top-i">
            <p>
              <span class="f12">剩余金币</span>
              <span class="f10">{{ userInfo.avaliableAmount }}</span>
            </p>
          </div>
          <div class="c-top-i">
            <p v-if="userInfo.vipType === 'none'">
              <span class="f12">未开通VIP</span>
            </p>
            <p v-else>
              <span class="f12">到期时间</span>
              <span class="f10">{{ userInfo.vipEndYear }}年{{ userInfo.vipEndMonth }}月{{ userInfo.vipEndDay }}日 {{
                  userInfo.vipEndHour
                }}时</span>
            </p>
          </div>
        </div>
        <div class="card-content">


          <div v-if="!isVip" class="billboards">
            <div class="f1">VIP会员</div>
            <div class="f2">开通后免费畅读千部漫画</div>
            <router-link to="/purchase" class="btn">立即开通</router-link>
          </div>

          <ul class="card-list">

            <li class="list-item t1">
              <router-link to="/user/bind">
                <span>绑定手机</span>
                <span v-if="userInfo.mobile === '' || userInfo.mobile === null" class="t-r c-red">强烈建议绑定手机</span>
                <span v-else class="t-r c-red">{{ userInfo.mobile }}</span>
              </router-link>
            </li>

<!--            <li class="list-item t10">-->
<!--              <router-link to="/user/find-account">-->
<!--                <span>找回充值账号</span>-->
<!--              </router-link>-->
<!--            </li>-->
            <li class="list-item t7">
              <a id="downloadBtn">
                <span class="c-red">{{ downloadDesc }}</span>
              </a>
            </li>
            <li class="list-item t9">
              <router-link to="/user/password">
                <span>修改密码</span>
              </router-link>
            </li>

            <li class="list-item t2">
              <router-link to="/purchase">
                <span>充值中心 <span class=" bc">特惠</span></span>
              </router-link>
            </li>

            <li class="list-item t5">
              <a id="customer">
                <span>在线客服</span>
                <span class="t-r">（11:00 ~ 18:00）</span>
              </a>
            </li>

            <li class="list-item t6">
              <a @click="openEmail()">
                <span>联系邮箱</span>
                <span class="t-r">{{ commInfo.customerServiceEmail }}</span>
              </a>
            </li>

          </ul>
        </div>
        <router-link to="/user/login" class="my-btn">切换账号</router-link>
      </div>

    </div>
    <a id="reportUrlUser" class="fixed-ts" style="z-index: 10"><span>投诉</span></a>
    <bottom></bottom>

    <div id="addScreenContainer" class="add-icon">
      <div class="dialog-bottom row">
        <div class="dialog-down"></div>
        <span class="cc">请点击</span>
        <span class="cc"><img class="img" src="../../assets/img/icon-20.png"></span>
        <span class="cc">然后点击“添加到主屏幕”</span>
      </div>
      <div class="dialog-mask" @click="hideAddContainer"></div>
    </div>
    <div id="payBackConfirm-modal" v-show="payBackConfirm" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>是否支付成功？</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="showPaySuccessAlert">是</button>
          <button class="btn" type="button" @click="showPayFailAlert">否</button>
        </div>
      </div>
    </div>
    <div id="paySuccess-modal" v-show="paySuccessAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts">
        <div class="find-success">
          <h3>
            请记住永久域名
            <a href="javascript:void(0);" @click="copyUrl('llmhuu.com')" style="color: #c32900; display: block;">
              <u>llmhuu.com</u>
            </a>
            <span v-if="inAndroidApp || inAndroidBrowser">或</span>
            <a v-if="inAndroidApp || inAndroidBrowser" ref="appDownloadA3" style="color: #c32900; display: block;">
              <u>下载最新APP</u>
            </a>
            防止账号丢失!
          </h3>
          <p>请<font color="red">截图保存账号密码</font>或<font color="red">绑定手机号</font></p>
          <p>账号：<strong>{{ userInfo.account }}</strong></p>
          <p>密码：<strong>{{ userInfo.password }}</strong></p>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="hidePaySuccessAlert">我已截图保存</button>
        </div>
      </div>
    </div>
    <div id="payFail-modal" v-show="payFailAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts">
        <h3>解决办法</h3>
        <div class="find-success">
          <p>1.请先截图保存当前账号密码</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;账号：<strong>{{ userInfo.account }}</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;密码：<strong>{{ userInfo.password }}</strong></p>
          <p v-show="inAndroidApp" style="margin-top:.5rem;">2.然后<a ref="appDownloadA1" style="color: #c32900;"><u>下载最新App</u></a> 进行支付</p>

          <p v-show="inAndroidBrowser" style="margin-top:.5rem;">2.然后<a ref="appDownloadA2" style="color: #c32900"><u>下载最新App</u></a> 进行支付</p>
          <p v-show="inIos">2.然后使用<font color="red">默认浏览器Safiri</font>进行支付</p>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="hidePayFailAlert">确定</button>
        </div>
      </div>
    </div>
    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>
  </div>
</template>

<script>
import Bottom from '@/components/layer1/bottom'
import Alert from '@/components/share/alert';
import userService from "../../services/userService";
import {getReportUrl, StaticApiBase} from "../../services/urlService";
import commService from "../../services/commService";
import payService from "../../services/payService";
import kkUtil from "../../assets/js/kk-util";
import {Kkconfig} from "../../assets/js/config";

export default {
  name: "user",
  data() {
    return {
      payBackConfirm: false,
      paySuccessAlert: false,
      payFailAlert: false,
      inAndroidApp: false,
      inAndroidBrowser: false,
      inIos: false,
      isLogin: true,
      isVip: false,
      userInfo: {},
      commInfo: {},
      inBrowser: true,
      clientType: 'ios',
      downloadDesc: 'App下载',
      imUrl: '',
      showAlert: false,
      alertMsg: ''
    }
  },
  methods: {
    getUserInfo() {
      userService.getUserInfo()
        .then(res => {
          if (res.result) {
            this.userInfo = res.data;
          }
        })
    },
    getStaticApiUrl(path) {
      return `${StaticApiBase}${path}`;
    },
    register() {
      userService.register()
        .then(res => {
          if (res.result) {
            this.userInfo = res.data;
          }
        })
    },
    buildDownload() {
      let downloadBtn = document.getElementById("downloadBtn");
      this.clientType = kkUtil.getClientType();
      if (this.clientType == "ios") {
        this.downloadDesc = "添加桌面快捷";
        downloadBtn.onclick = function () {
          let container = document.getElementById("addScreenContainer");
          container.style.display = 'block';
        }
      } else {
        this.downloadDesc = "App下载";
        downloadBtn.href = this.commInfo.appDownloadUrl;
      }
    },
    hideAddContainer() {
      let container = document.getElementById("addScreenContainer");
      container.style.display = 'none';
    },
    openEmail() {
      userService.openEmail(this.commInfo.customerServiceEmail, 'home');
    },
    openQQ() {
      userService.openQQ(this.commInfo.customerServiceQQ, 'home');
    },
    showPaySuccessAlert() {
      this.payBackConfirm = false;
      this.paySuccessAlert = true;
    },
    hidePaySuccessAlert() {
      this.paySuccessAlert = false;
    },
    showPayFailAlert() {
      this.payBackConfirm = false;
      this.payFailAlert = true;
    },
    hidePayFailAlert() {
      this.payFailAlert = false;
    },
    copyUrl(url){
      (function(){
        document.oncopy = function(e){
          e.clipboardData.setData('text',url)
          e.preventDefault();
          document.oncopy = null;
        }
      })(url);
      document.execCommand('Copy');
      this.alertMsg = '复制成功';
      this.showAlert = true;
    }
  },
  components: {
    bottom: Bottom,
    alert: Alert
  },
  mounted() {
    let $this = this;
    let currUser = userService.getLocalUserInfo();
    if (!currUser) {
      this.register();
    } else {
      this.getUserInfo();
    }
    this.$router.isBack = true;
    this.commInfo = commService.getLocalInitData();
    this.clientType = kkUtil.getClientType();
    this.inBrowser = !kkUtil.isInWebView();
    setTimeout(function () {
      $this.buildDownload();
    }, 1000);
    document.getElementById("reportUrlUser").href = getReportUrl(currUser.account);
  },
  watch: {
    userInfo: function () {
      this.$nextTick(function () {
        //document.getElementById("userHeadImg").src = this.getStaticApiUrl(this.userInfo.headImg);
        document.getElementById("userAccount").innerHTML = this.userInfo.account;
        document.getElementById("userPassword").innerHTML = "密码：" + this.userInfo.password;
        document.getElementById("customer").href = this.imUrl = Kkconfig.reqUrl.imUrl + "?account=" + this.userInfo.account;
        //支付返回后的弹框逻辑
        if (this.userInfo != null && payService.needAlertPayWarning()) {
          if (this.clientType == "android") {
            if (this.inBrowser) {
              //安卓浏览器
              this.inAndroidBrowser = true;
            } else {
              //安卓app
              this.inAndroidApp = true;
            }
          } else {
            //iOS
            this.inIos = true;
          }
          this.payBackConfirm = true;
          // this.$refs.appDownloadHome.textContent = this.commInfo.appDownloadHome;
          this.$refs.appDownloadA1.href = this.commInfo.appDownloadUrl;
          this.$refs.appDownloadA2.href = this.commInfo.appDownloadUrl;
          this.$refs.appDownloadA3.href = this.commInfo.appDownloadUrl;
        }
      });
    }
  }
}
</script>

<style scoped>
#pop-page {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/layer1/user.vue